import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  ShipmentTransportOrderPartiesListStateModel,
  ShipmentTransportOrderPartiesState,
} from './shipment-transport-order-parties.state';
import {
  ShipmentTransportOrderPartiesListInitialState,
  ShipmentTransportOrderPartiesListLoad,
} from './shipment-transport-order-parties.actions';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { TransportOrderIdView } from '../../../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderPartiesFacade implements LoadDataFacade, SetInitialStateFacade {
  list$: Observable<ShipmentTransportOrderPartiesListStateModel> = this.store.select(
    ShipmentTransportOrderPartiesState.getState,
  );
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderPartiesState.getLoaded);

  constructor(private store: Store) {}

  loadAll(transportOrderIdView: TransportOrderIdView): void {
    this.store.dispatch(new ShipmentTransportOrderPartiesListLoad(transportOrderIdView));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderPartiesListInitialState());
  }
}
